import Swiper from 'swiper';
import { Pagination, Navigation, A11y } from 'swiper/modules';
import 'swiper/css';

const prevSlideLabel = strl_vars.previous_slide_message;
const nextSlideLabel = strl_vars.next_slide_message;

const projectSlider = new Swiper('.slider-projects', {
	modules: [Navigation, Pagination, A11y],
	a11y: true,
	grabCursor: true,
	loop: true,
	slidesPerView: 1.2,
	spaceBetween: 16,
	keyboard: {
		enabled: true,
	},
	a11y: {
		prevSlideMessage: prevSlideLabel,
		nextSlideMessage: nextSlideLabel,
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	pagination: {
		el: '.swiper-pagination',
		type: 'fraction',
		renderFraction: function (currentClass, totalClass) {
			return (
				'<span class="' +
				currentClass +
				'"></span> ' +
				strl_vars.pagination_of +
				' <span class="' +
				totalClass +
				'"></span>'
			);
		},
	},
	breakpoints: {
		768: {
			slidesPerView: 2.2,
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 32,
		},
	},
	on: {
		afterInit: (swiper) => {
			if (swiper.slides.length <= swiper.params.slidesPerView) {
				swiper.el.querySelector('.swiper-navigation').classList.add('hidden');
			}
			if (swiper.slides.length < swiper.params.slidesPerView * 2) {
				swiper.params.loop = false;
				return;
			}
			if (swiper.wrapperEl && swiper.slides.length && swiper.slides.length >= swiper.params.slidesPerView + 2) {
				swiper.params.loopAdditionalSlides = 1;
				swiper.wrapperEl.prepend(swiper.slides[swiper.slides.length - 1]);
			}
		},
		slideChange: (swiper) => {
			const pageTotal = swiper.el.querySelector('.swiper-pagination-total');
			if (pageTotal) {
				pageTotal.innerHTML = swiper.slides.length;
			}
		},
	},
});
